// Everything that differs between the mobil and the trado editor, in one place.
// The editor hooks / components in features/cek-keluar-masuk/{hooks,components} read these values.
const editorConfig = {
  // url part that tells the "berangkat" page apart from the "kembali" page
  berangkatUrlPart: "cek-keluar-masuk/berangkat",

  // vehicles the vehicle selector may show (mobil: everything except trado)
  kendaraanSelectorFilter: "data_kendaraan_jenis.nama:!=:Trado",

  // the vehicle can only be changed on the "berangkat" page
  lockVehicleOnKembali: false,

  // marking options are filtered by vehicle type (mobil: everything except trado 16,17)
  kendaraanJenisFilter: "notin:16,17",

  // whether the trailer cards (checklist + photos) apply: mobil only when the header has a trailer
  hasTrailer: (headerData) => !!(headerData.trailer_id || headerData.data_trailer),

  // extra keys removed from the header before it is saved
  saveHeaderDeleteKeys: [],

  // part appended to the problem filter for the trailer(s)
  getTrailerProblemFilter: (headerData) => {
    if (headerData.trailer_id && headerData.trailer_id > 0) {
      return `||trailer_id:=:${headerData.trailer_id}`;
    }
    return "";
  },

  // vehicle lines of the WhatsApp report ("No.pol" up to "Tujuan")
  buildWhatsappVehicleLines: (headerData) => {
    let lines = "";
    lines += `No.pol : ${headerData.data_kendaraan?.nomor_polisi}\n`;
    lines += `Supir Berangkat : ${headerData.data_supir?.nama} \n`;
    lines += `Supir Pulang : ${headerData.data_supir_pulang?.nama} \n`;
    lines += `Tujuan : ${headerData.data_tujuan?.nama} \n`;
    return lines;
  },
};

export default editorConfig;
